;var jcms = jcms ? jcms : config;
/**
 * Lazy Loader - v2
 * Lazily loads images while user scrolls website
 *
 * Copyright: 2021 Jonah Digital Agency
 * Created by: Erik Uunila (erik.uunila@jonahdigital.com)
 *
 * add data-src="url-to-image"
 * allows use of data-srcset="" for IMG & PICTURE SOURCE
 *
 * add data-embed="code-to-insert"
 * to add embed code that replaces elements .html()
 *
 * init: $(element).lazyload({options});
 */
;(function($, jcms) {
  'use strict';

  $.lazyload = {
    defaults: {
      triggerClass: 'lazyload',
      preloadClass: 'lazyload--loading',
      postloadClass: 'lazyload--loaded',
      mobile: 808,
      offset: 0,
      force: false
    },

    observerOptions: {
      // null = browser viewport
      root: null,
      rootMargin: '60px 0px',
      threshold: 0,
    },

    observer: null,

    loadedAssets: [],

    init: function(elements, options) {
      // extend defaults if options passed
      $.lazyload.settings = $.fn.extend({}, $.lazyload.defaults, options);

      // load all elements to observe
      var assetsToObserve = elements;

      if (jcms.breakpointListener) {
        jcms.breakpointListener.registerCallback(function() {
          $.lazyload.reobserveLoadedAssets();
        }, true);
      }

      // check if `force` option is set to true
      if ($.lazyload.settings.force) {
        for (var i = 0; i < assetsToObserve.length; i++) {
          $.lazyload.loadAsset(assetsToObserve[i]);
        }
      }
      // check if browser supports IntersectionObserver
      else if ("IntersectionObserver" in window) {
        $.lazyload.observer = new IntersectionObserver($.lazyload.update, $.lazyload.observerOptions);
        $.each(assetsToObserve, function(index, asset) {
          if (asset.tagName === 'SOURCE') {
            asset = asset.parentNode;
          }
          $.lazyload.observer.observe(asset);
        });
      }
      // old browser just load it, don't wait for scroll
      else {
        for (var i = 0; i < assetsToObserve.length; i++) {
          $.lazyload.loadAsset(assetsToObserve[i]);
        }
      }

      // reset some stuff after page load
      if ("IntersectionObserver" in window) {
        setTimeout(function() {
          $.lazyload.observer.disconnect();
          $.lazyload.observerOptions.rootMargin = Math.max(300, parseInt(2 * (window.innerHeight || 300) / 3)) + "px 0px";
          $.lazyload.observer = new IntersectionObserver($.lazyload.update, $.lazyload.observerOptions);
          $.each(assetsToObserve, function(index, asset) {
            if (asset.tagName === 'SOURCE') {
              asset = asset.parentNode;
            }
            $.lazyload.observer.observe(asset);
          });
        }, 1500);
      }
    },

    update: function(data, options) {
      data.forEach(function(entry) {
        if (entry.isIntersecting) {
          $.lazyload.observer.unobserve(entry.target);
          $.lazyload.loadAsset(entry.target);
        }
      });
    },

    loadAsset: function(element) {
      if ('classList' in document.createElement('p')) {
        element.classList.add($.lazyload.settings.preloadClass);
        $.lazyload.loadType(element);
        $.lazyload.loadedAssets.push(element);
        element.classList.remove($.lazyload.settings.preloadClass);
        element.classList.add($.lazyload.settings.postloadClass);
      }
      // IE sucks
      else {
        var preload = new RegExp('(\\s|^)' + $.lazyload.settings.preloadClass + '(\\s|$)');
        element.className += ' ' + $.lazyload.settings.preloadClass;
        $.lazyload.loadType(element);
        $.lazyload.loadedAssets.push(element);
        element.className.replace(preload, '');
        element.className += ' ' + $.lazyload.settings.postloadClass;
      }
    },

    loadType : function(element) {
      switch (element.tagName) {
        case 'IMG':
          var parent = element.parentNode;
          if (parent && parent.nodeName === 'PICTURE') {
            $.lazyload.loadPicture(parent);
          }
          else {
            $.lazyload.loadImage(element);
          }
          break;
        case 'PICTURE':
          $.lazyload.loadPicture(element);
          break;
        case 'IFRAME':
          $.lazyload.loadIFrame(element);
          break;
        case 'VIDEO':
          $.lazyload.loadVideo(element);
          break;
        default:
          $.lazyload.loadBackgroundImage(element);
          break;
      }
    },

    loadImage: function(image) {
      var src = image.getAttribute('data-src');
      var sizes = image.getAttribute('data-sizes');
      var srcset = image.getAttribute('data-srcset');

      if (src || srcset) {
        if (srcset) {
          if (!image.getAttribute('sizes') && !sizes) {
            var parentWidth = $.lazyload.getElementWidth(image.parentNode) || 1;
            image.sizes = 100 * parentWidth + 'vw';
          }
          else if (sizes) {
            image.sizes = sizes;
          }
          image.setAttribute('srcset', srcset);
        }

        if (src) {
          image.src = src;
        }
      }
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-sizes');
      image.removeAttribute('data-src');
    },

    loadPicture: function(picture) {
      if (picture.children) {
        var image = picture.querySelector('img');
        var sources = picture.getElementsByTagName('source');

        if (!image && !sources) {
          return;
        }

        for (var i = 0; i < sources.length; i++) {
          var srcset = sources[i].getAttribute('data-srcset');
          if (srcset) {
            sources[i].srcset = srcset;
            sources[i].removeAttribute('data-srcset');
          }
        }

        if (image) {
          $.lazyload.loadImage(image);
        }
      }
    },

    loadIFrame: function(iframe) {
      var src = iframe.getAttribute('data-src');
      if (src) {
        iframe.src = src;
        iframe.removeAttribute('data-src');
      }
    },

    loadVideo: function(video) {
      var src = video.getAttribute('data-src');
      if (!src) {
        for (var source in video.children) {
          if (source) {
            var videoSource = video.children[source];
            if (typeof videoSource.tagName === 'string') {
              if (videoSource.tagName === 'SOURCE') {
                videoSource.src = videoSource.getAttribute('data-src');
                videoSource.removeAttribute('data-src');
              }
              else if (videoSource.tagName === 'IMG') {
                $.lazyload.loadImage(videoSource);
              }
            }
          }
        }
      }
      else {
        video.src = src;
      }

      video.load();
      video.removeAttribute('data-src');
    },

    loadBackgroundImage: function(element) {
      var embed, src;
      if (embed = element.getAttribute('data-embed')) {
        if (embed !== 'none' && embed !== null && embed.length > 0) {
          $(element).html(embed);
          element.removeAttribute('data-embed');
        }
      }
      else {
        src = element.getAttribute('data-src');
        if (src !== 'none' && src !== null && src.length > 0) {
          element.style.backgroundImage = "url('" + src + "')";
          element.removeAttribute('data-src');
        }
      }
    },

    getElementWidth: function(element) {
      return Math.ceil(100 * element.offsetWidth / document.body.offsetWidth) / 100;
    },

    reobserveLoadedAssets: function() {
      for (var i = 0; i < $.lazyload.loadedAssets.length; i++) {
        if ($.lazyload.isElementInViewport($.lazyload.loadedAssets[i])) {
          $.lazyload.loadType($.lazyload.loadedAssets[i]);
        }
      }
    },

    isElementInViewport : function(element) {
      var anchorBoundingBoxViewport = element.getBoundingClientRect();
      return anchorBoundingBoxViewport.top >= 0 && anchorBoundingBoxViewport.left >= 0 && anchorBoundingBoxViewport.bottom <= (window.innerHeight || document.documentElement.clientHeight) && anchorBoundingBoxViewport.right <= (window.innerWidth || document.documentElement.clientWidth);
    }
  };

  $.fn.lazyload = function(options) {
    var elements = this;
    new $.lazyload.init(elements, options);
  };

})(window.jQuery, jcms);
